import React, { useEffect, useRef, useState } from 'react'
import useMakeRequest from '../utils/ApiHelper';
import { ApiConstants } from '../constants/ApiConstants';
import { ApiTypes } from '../constants/Constants';

function VerfiyOtpEmail(props:any) {
    const [otppopu, setOtpPopu] = useState(false)
    const VerifyEmail = useMakeRequest()
  const [isTimerRunning, setIsTimerRunning] = useState(false);

  const numberOfDigits = 4;
  const regex = /^[0-9\b]+$/;
    const otpBoxRef = useRef<any>([]);
    const OTP = useMakeRequest()
    let countdown: any;

    const [otpData, setOtpData]: any = useState('')
    const [tempdata, setTempdata] = useState<any>({})
    const [otpError, setOtpError] = useState('');
    const [otp, setOtp]: any = useState(new Array(numberOfDigits).fill(""));
      const [timer, setTimer] = useState(120);
    
     const handleChange = (value: any, index: any) => {
        setOtpError('')
        if (value === '' || regex.test(value)) {
          let newArr = [...otp];
          newArr[index] = value;
          setOtp(newArr);
          setOtpData(newArr.join(''))
    
        }
    
        if (value && regex.test(value) && index < numberOfDigits - 1) {
          otpBoxRef.current[index + 1].focus();
        }
      }
      const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          // handleVerify()
        }
      }
      const onPaste = (event: any) => {
        const pasted = event.clipboardData.getData("text/plain")
        if (pasted.length === numberOfDigits && regex.test(pasted)) {
          setOtpError('')
          setOtpData(pasted)
          setOtp(pasted.split("").slice(0, numberOfDigits))
        }
    
      }
      const handleVerify = () => {
        if (otp.join("") == "" || otpData?.length < 4) {
          return setOtpError('Please enter OTP.')
        }
        setOtpError('');
        let payload = {
          email: props?.email,
          otp: otpData,
          verify_type: "OTP_MAIL_VERIFY"
        }
        OTP.makeRequest({ payload, url: ApiConstants?.VerifyEmailOtp, toastStatus: true })
      }
       const handleBackspaceAndEnter = (e: any, index: any, otpBoxRef: any, numberOfDigits: any) => {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            return otpBoxRef.current[index - 1].focus();
        }
        if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
            return otpBoxRef.current[index + 1].focus();
        }
      }
   useEffect(()=>{
    if(OTP.status){
      props?.setOtpShow(false)
      props?.setVerfiy(false)
    }else{
    setIsTimerRunning(true)
    }
   },[OTP.status]) 

     useEffect(() => {
       if (isTimerRunning && timer > 0) {
         countdown = setInterval(() => {
           setTimer((prevTimer) => prevTimer - 1);
         }, 1000);
       } else if (timer === 0) {
         clearInterval(countdown);
         setIsTimerRunning(false);
       }
       return () => {
         clearInterval(countdown);
       };
     }, [isTimerRunning, timer]);

    const handelResendOtp =()=>{
       const payload = {
         email:props?.email
       }
       VerifyEmail.makeRequest({ payload, type:ApiTypes.POST, url: ApiConstants?.VerifyEmail, toastStatus: true })
       }
       useEffect(()=>{
        if(VerifyEmail.status){
          setIsTimerRunning(true)
          setTimer(120)
        }
        },[VerifyEmail?.status])
  return (
    <>
     <div className="modal fade auth-modal text-center show" id="forgotPassModal" aria-labelledby="forgotPassModalLabel" aria-hidden="false" style={{ display: 'block' }} >
    
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <button type="button" onClick={() => props?.setOtpShow(false)} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square"></i></button>
                  <div className="modal-body">
                    <h5 className="auth-modal-ttl mb-2">OTP Verification</h5>
                    <p className="auth-modal-small-txt">Enter the 4 digit OTP sent to ****{props?.email?.split('@')[1]}</p>
                    <div className="otp-inputs">
                      {
                        otp.map((digit: any, index: any) => {
                          return (
                            <input className='form-control' key={index}
                              value={digit} onPaste={onPaste} maxLength={1} ref={(ref) => (otpBoxRef.current[index] = ref)}
                              type="text"
                              placeholder="*"
                              onChange={(e) => handleChange(e.target.value, index)}
                              onKeyDown={handleKeyDown}
                              onKeyUp={(e) => handleBackspaceAndEnter(e, index, otpBoxRef, numberOfDigits)}
                            />
                          )
                        })
                      }
                    </div>
                    <p style={{ color: 'red' }} >{otpError}</p>
                    {isTimerRunning ?  
                <div className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4">Resend in :{timer} s</div>
                :
                <button className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4" onClick={()=>handelResendOtp()}>Resend OTP</button>
                }
                    <button type="button" onClick={handleVerify} className="auth-modal-btn round-btn mt-4 w-50 d-block mx-auto" data-bs-dismiss="modal">Verify</button>
                  </div>
                </div>
              </div>
            </div>
    </>
  )
}

export default VerfiyOtpEmail